// src/pages/SalesWorkflow.jsx
import React from 'react';
import ZoomableImage from '../components/ZoomableImage';
import './Workflows.css';

export default function SalesWorkflow() {
  const svgPath = '/svgs/nesim-sales-workflow.svg';

  return (
    <div className="workflow-page">
      <h1>NESIM Sales Workflow</h1>
      <p>
        This flowchart demonstrates our sales process, covering lead generation, customer onboarding, sales negotiation, and post-sales follow-up.
      </p>

      <div className="svg-container">
        <ZoomableImage src={svgPath} alt="NESIM Sales Workflow" />
      </div>

      <div className="download-container">
        <a
          href={svgPath}
          download="nesim-sales-workflow.svg"
          className="download-button"
        >
          Download SVG
        </a>
      </div>
    </div>
  );
}
